import { FC, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Space, Tabs } from 'antd';
import { APPOINTMENT_VIEW_DASHBOARD } from 'constants/appointments';
import { CalendarOutlined, FormOutlined } from '@ant-design/icons';
import {
  LegacyAppointment,
  fetchAppointments
} from 'services/api/appointments';

import { Loading } from 'components/ui';
import { groupByStatus } from 'utils/appointments';
import TabItem from '../TabItem';

const Appointments: FC = () => {
  const { t } = useTranslation();

  const [appointments, setAppointments] = useState<LegacyAppointment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAppointments({ page: 1, limit: 999 })
      .then(res => setAppointments(res.results))
      .catch(() => setAppointments([]))
      .finally(() => setLoading(false));
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const appointmentsSection = groupByStatus(appointments as any[], 'status');

  if (loading) {
    return <Loading />;
  }

  return (
    <Card style={{ minHeight: 335 }}>
      <Tabs
        items={Object.keys(APPOINTMENT_VIEW_DASHBOARD).map(item => ({
          label: (
            <Space size={12}>
              {item === '1' ? <FormOutlined /> : <CalendarOutlined />}
              <span style={{ fontSize: 20 }}>
                {t(`dashboard.${APPOINTMENT_VIEW_DASHBOARD[item]}`)}
              </span>
            </Space>
          ),
          key: item,
          children: <TabItem data={appointmentsSection[item]} />
        }))}
      />
    </Card>
  );
};

export default memo(Appointments);
